import { lazy, Suspense } from 'react';
import { useUnit } from 'effector-react';

import { getCurrentEmployeeFx } from 'shared/api';
import { $isAuthenticated, $token } from 'shared/auth';
import { NotificationsProvider } from 'shared/notifier';
import { theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';
import { ErrorBoundary } from 'shared/ui/ErrorBoundary/ErrorBoundary';
import { ErrorWithHelpLink } from 'shared/ui/ErrorWithHelpLink';
import { Spinner } from 'shared/ui/Spinner';
import { $currentUser } from 'entities/currentUser';
import { UpdateAppPopup } from 'features/updateApp';
import { Survey } from 'widgets/survey';
import { PageFallback } from 'pages/Fallback';

import { $needUpdate } from './updater';

import './app.css';
import 'normalize.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/montserrat/800.css';
import './model';
import { ThemeProvider } from '@emotion/react';

const Router = lazy(() => import('./Router'));

export const App = () => {
  const isAuthenticated = useUnit($isAuthenticated);
  const token = useUnit($token);
  const currentUser = useUnit($currentUser);
  const currentUserPending = useUnit(getCurrentEmployeeFx.pending);
  const needUpdate = useUnit($needUpdate);

  if (!isAuthenticated || !token || currentUserPending) {
    return (
      <Box height='100vh' width='100vw' display='flex' justifyContent='center' alignItems='center'>
        <Spinner />
      </Box>
    );
  }

  if (!currentUser && !currentUserPending) {
    return <ErrorWithHelpLink />;
  }

  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <NotificationsProvider>
          <Suspense fallback={<PageFallback />}>
            <Survey />
            <Router />
            <UpdateAppPopup visible={needUpdate} />
          </Suspense>
        </NotificationsProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};
